export default __webpack_public_path__ + "static/media/11.978c7bf0.jpg";